import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DialogService } from '../../_services/shared/dialog.service';
import { TabChangeService } from 'src/app/_services/shared/tab-change.service';

export class ComponentCanDeactivate {
  canDeactivate: () => boolean | Promise<boolean>;
}



@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard  {

  constructor(private dialogService: DialogService, private tabChangeService: TabChangeService) {

  }

  canDeactivate(component: ComponentCanDeactivate, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean> {                 
      if (this.tabChangeService.canDeactivateTab()) {
        return of(true);
      } else {
        return this.dialogService.openConfirmDialog('You have unsaved changes that will be lost when you navigate away from this page. Press OK to continue (your work will not be saved), or Cancel to stay on the current page.', 'Ok', 'Cancel')
          .afterClosed();
      }
  }


}
